import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
// material-ui
import { useTheme, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SpinnerLoader from 'ui-component/Spinner';
import ReCAPTCHA from 'react-google-recaptcha';
// third party
import * as Yup from 'yup';
import { Formik } from 'formik';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import AnimateButton from 'ui-component/extended/AnimateButton';
import useAuth from 'hooks/useAuth';
import Typography from '@mui/material/Typography';
import { IconPhone,IconUser,IconPassword } from '@tabler/icons-react';
// nes 
import Stack from '@mui/material/Stack';
import { sendMobileOtp } from 'api/UserApi';

const countryCodes = [
    {
        label: 'Philippines',
        src: 'https://flagicons.lipis.dev/flags/4x3/ph.svg',
        value: '+63',
        country_code: '+63'
    }
];

const LoginView = styled(Stack)(({ theme }: LoginView) => ({
    '.MuiFormControl-root': { marginBottom: '8px' },
    'p.Mui-error': {
        position: 'absolute',
        bottom: '-20px',
        left: '-14px',
        [theme.breakpoints.down(380)]: {
            fontSize: '10px'
        }
    },
    '.MuiCheckbox-colorWarning': {
        color: '#ff0000',
        '.svg': { fill: '#ff0000' },
        '.h6': { color: '#ff0000' }
    }
}));

const LoginBox = styled(Box)({});

const JWTLogin = () => {
    const { login } = useAuth();
    const theme = useTheme();
    const [errorMessage, setErrorMessage] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);
    const [otpResponse, setOtpResponse] = useState({});
    const [resendTimer, setResendTimer] = useState(false);
    const [resendCountdown, setResendCountdown] = useState(30);
    const [checked, setChecked] = React.useState(true);
    const [ageCheck, seAgeChecked] = React.useState(true);
    const [rulesChecked, seRulesChecked] = React.useState(true);
    const [isAgeError, setIsAgeError] = React.useState(false);
    const [isTerrmError, setIsTermError] = React.useState(false);
    const [isRulesError, setIsRulesError] = React.useState(false);

    const sendOtp = async (phone: string | null) => {
        debugger;
        const response = await sendMobileOtp(phone);
        if (response.status === 'success') {
            setOtpResponse(response);
            setOtpSent(true);
            startResendTimer();
        } else {
            setErrorMessage(response.message);
        }
    };

    const verifyOtpLogin = async (fullPhone: string | null, otp: string | null, otpResponse: any) => {
        const { error } = await login(fullPhone, otp, otpResponse, 'phone');
        if (error) setErrorMessage(error);
    };

    const startResendTimer = () => {
        let count = 30;
        setResendCountdown(count);
        setResendTimer(true);

        const interval = setInterval(() => {
            count -= 1;
            setResendCountdown(count);
            if (count <= 0) {
                clearInterval(interval);
                setResendTimer(false);
            }
        }, 1000);
    };

    const validationSchema = Yup.object().shape({
        username: Yup.string().required('Username is required'),
        password: Yup.string().required('Password is required')
    });

    return (
        <LoginView>
            <Formik
                initialValues={{
                    username: '',
                    password: '',
                    submit: null
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                    try {
                        setErrorMessage('');

                        const { error } = await login(values.username, values.password, null, 'username');

                        if (error) {
                            setErrorMessage(error);
                            setErrors({ submit: error });
                        }

                        setStatus({ success: true });
                        setSubmitting(false);
                    } catch (err: any) {
                        setErrorMessage(err?.message || 'Login failed');
                        setErrors({ submit: err?.message });
                        setSubmitting(false);
                    }
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                    <form noValidate onSubmit={handleSubmit}>
                        <LoginBox>
                            <Grid sx={{ gap: '10px', display: 'flex' }}>
                                {/* <FormControl
                                    fullWidth
                                    error={Boolean(touched.countrycode && errors.countrycode)}
                                    sx={{
                                        ...theme.typography.customInput,
                                        width: '30%',
                                        [theme.breakpoints.down(600)]: {
                                            width: '30%'
                                        }
                                    }}
                                >
                                    <InputLabel
                                        sx={{
                                            position: 'absolute',
                                            top: '0px !important'
                                            // color: '#121926 !important'
                                        }}
                                        id="age-select"
                                    >
                                        Country Code
                                    </InputLabel>
                                    <Select
                                        labelId="outlined-adornment-countrycode-register"
                                        id="outlined-adornment-countrycode-register"
                                        value={values.countrycode}
                                        name="countrycode"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        label="Country Code"
                                        sx={{ padding: '0px' }}
                                    >
                                        {countryCodes.map((country: any) => (
                                            <MenuItem
                                                sx={{
                                                    [theme.breakpoints.down(600)]: {
                                                        padding: '0px'
                                                    }
                                                }}
                                                key={country.country_code}
                                                value={country.country_code}
                                            >
                                                <img
                                                    loading="lazy"
                                                    width={15}
                                                    height={15}
                                                    src={country.src}
                                                    alt={`Flag of ${country.label}`}
                                                    style={{
                                                        marginRight: 8,
                                                        marginTop: '3px',
                                                        [theme.breakpoints.down(600)]: {
                                                            marginRight: 4
                                                        }
                                                    }}
                                                />
                                                <Typography
                                                    sx={{
                                                        fontSize: '14px',
                                                        fontWeight: '900',
                                                        [theme.breakpoints.down(600)]: {
                                                            fontSize: '12px',
                                                            fontWeight: '700'
                                                        }
                                                    }}
                                                >
                                                    {' '}
                                                    ({country.country_code})
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl> */}

                                <FormControl
                                    fullWidth
                                    error={Boolean(touched.username && errors.username)}
                                     sx={{ ...theme.typography.customInput, width: '100%' }}
                                >
                                    <TextField
                                        id="outlined-adornment-phone-login"
                                        type="text"
                                        value={values.username}
                                        name="username"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        label="Username"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton edge="end" size="small">
                                                        <IconUser />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        error={touched.username && Boolean(errors.username)}
                                        helperText={touched.username && errors.username}
                                    />
                                </FormControl>

                                {/* <FormControl
                                    fullWidth
                                    error={Boolean(touched.phone && errors.phone)}
                                    sx={{ ...theme.typography.customInput, width: '100%' }}
                                >
                                    <TextField
                                        id="outlined-adornment-phone-login"
                                        type="text"
                                        value={values.phone}
                                        name="phone"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        label="Mobile"
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                            maxLength: 12
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton edge="end" size="small">
                                                        <IconPhone />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        error={touched.phone && Boolean(errors.phone)}
                                        helperText={touched.phone && errors.phone}
                                    />
                                </FormControl> */}
                               
                            </Grid>
                            <Grid sx={{ gap: '10px', display: 'flex' }}>
 <FormControl
                                    fullWidth
                                    error={Boolean(touched.password && errors.password)}
                                     sx={{ ...theme.typography.customInput, width: '100%' }}
                                >
                                    <TextField
                                        id="outlined-adornment-password-login"
                                        type="password"
                                        value={values.password}
                                        name="password"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        label="Password"
                                         InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton edge="end" size="small">
                                                        <IconPassword />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        error={touched.password && Boolean(errors.password)}
                                        helperText={touched.password && errors.password}
                                    />
                                </FormControl>

                            </Grid>

                            {otpSent && (
                                <>
                                    <FormControl
                                        fullWidth
                                        error={Boolean(touched.otp && errors.otp)}
                                        sx={{ ...theme.typography.customInput }}
                                    >
                                        <TextField
                                            id="outlined-adornment-otp-login"
                                            type="text"
                                            value={values.otp}
                                            name="otp"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            label="OTP"
                                            inputProps={{
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*'
                                            }}
                                            error={touched.otp && Boolean(errors.otp)}
                                            helperText={touched.otp && errors.otp}
                                        />
                                    </FormControl>

                                    <Box sx={{ mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography sx={{ fontSize: '14px', color: '#666' }}>
                                            {resendTimer ? `Resend OTP in ${resendCountdown}s` : ''}
                                        </Typography>

                                        <Button
                                            disabled={resendTimer}
                                            size="small"
                                            variant="text"
                                            onClick={async () => {
                                                const fullPhone = values.phone;
                                                await sendOtp(fullPhone);
                                                startResendTimer();
                                            }}
                                            sx={{
                                                color: 'rgb(255, 188, 69)', // Text color when enabled
                                                '&.Mui-disabled': {
                                                    color: '#000', // Text color when disabled
                                                    backgroundColor: 'rgba(255, 255, 0, 0.3)' // Optional: yellowish background for disabled
                                                },
                                                textTransform: 'none',
                                                fontWeight: 500
                                            }}
                                        >
                                            Resend OTP
                                        </Button>
                                    </Box>
                                </>
                            )}

                            {errors.submit && (
                                <Box sx={{ mt: 3, mb: 3 }}>
                                    <FormHelperText error>{errors.submit}</FormHelperText>
                                </Box>
                            )}

                            <Typography sx={{ color: '#f44336', mt: 3, mb: 3 }}>{!!errorMessage && errorMessage}</Typography>
                            {/* 
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                // checked={checked}
                                                onChange={(event) => seAgeChecked(event.target.checked)}
                                                name="checked"
                                                color={`${isAgeError ? 'warning' : 'primary'}`}
                                                sx={{ padding: '5px 9px' }}
                                            />
                                        }
                                        label={
                                            <Typography
                                                variant="subtitle1"
                                                sx={{
                                                    color: theme.palette.secondary.main,
                                                    whiteSpace: 'nowrap',
                                                    [theme.breakpoints.down(600)]: {
                                                        fontSize: '12px'
                                                    }
                                                }}
                                            >
                                                I declare that I am at least 21 years old
                                            </Typography>
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => setChecked(event.target.checked)}
                                                name="checked"
                                                color={`${isTerrmError ? 'warning' : 'primary'}`}
                                                sx={{ padding: '5px 9px' }}
                                            />
                                        }
                                        label={
                                            <Typography
                                                variant="subtitle1"
                                                sx={{
                                                    color: theme.palette.secondary.main,
                                                    [theme.breakpoints.down(600)]: {
                                                        fontSize: '12px'
                                                    }
                                                }}
                                            >
                                                Agree with &nbsp;
                                                <Typography
                                                    onClick={() => handlePageChange()}
                                                    variant="subtitle1"
                                                    component={Link}
                                                    to="/termscondition"
                                                    sx={{ color: theme.palette.secondary.main }}
                                                >
                                                    Terms & Condition.
                                                </Typography>
                                            </Typography>
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => seRulesChecked(event.target.checked)}
                                                name="checked"
                                                color={`${isRulesError ? 'warning' : 'primary'}`}
                                                sx={{ padding: '5px 9px' }}
                                            />
                                        }
                                        label={
                                            <Typography
                                                variant="subtitle1"
                                                sx={{
                                                    color: theme.palette.secondary.main,
                                                    whiteSpace: 'nowrap',
                                                    [theme.breakpoints.down(600)]: {
                                                        fontSize: '12px'
                                                    }
                                                }}
                                            >
                                                I am not a government official, or employee connected <br /> directly with the operation of
                                                the Government or any <br /> of its agencies, member of the Armed Forces of the <br />
                                                Philippines, including the Army, Navy, Air Force, <br /> or the Philippine National Police.
                                                <br />I am not a Gaming Employment License (GEL) holder.
                                            </Typography>
                                        }
                                    />
                                </Grid>
                            </Grid> */}

                            <Box sx={{ mt: 2 }}>
                                <AnimateButton>
                                    <Button
                                        sx={{
                                            backgroundColor: theme.palette.secondary.main,
                                            color: theme.palette.grey[500],
                                            boxShadow: 'inherit',
                                            mb: '10px',
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            '&:hover': {
                                                backgroundColor: theme.palette.secondary.main,
                                                color: theme.palette.grey[500]
                                            }
                                        }}
                                        color="secondary"
                                        disabled={isSubmitting}
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                    >
                                        {otpSent ? 'Login' : 'Login'} {isSubmitting && <SpinnerLoader />}
                                    </Button>
                                </AnimateButton>
                            </Box>
                        </LoginBox>
                    </form>
                )}
            </Formik>
        </LoginView>
    );
};

export default JWTLogin;
